import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as authApi from 'api/auth-api';
import {getAssets} from 'api/asset-api';
import {logoutSuccess} from 'actions/user-actions';
import {getAssetsFromBuffer, refillBuffer} from 'actions/asset-actions';
import {showInfiniteScrollLoader} from 'actions/ui-actions'
import EmptyGallery from 'components/views/empty-list';
import store from 'store';
import {hideSpinner} from 'utils/spinner';
import scrollUtils from 'utils/scroll-utils';

import conf from 'config/app-config';
import Gallery from "../views/gallery";
import _ from 'lodash';
import {clearAssets} from 'actions/asset-actions'


class GalleryContainer extends Component {

    constructor(props) {
        super(props);
        this.onScrollBound = _.debounce(this.onScroll.bind(this), 150);

    }

    componentDidMount() {
        window.scrollTo(0, scrollUtils.getLastWindowPosition());

        this.images = {};
        window.addEventListener('scroll', this.onScrollBound);
        hideSpinner();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollBound);
        this.images = {};
    }

    onScroll() {
        const leftToBottom = document.body.scrollHeight - window.innerHeight - document.body.scrollTop;
        scrollUtils.setLastWindowPosition(document.body.scrollTop);
        if (leftToBottom < 150) {
            const {assets, buffer} = store.getState().assetsState;
            const profile = store.getState().userProfile;
            const assetsLength = assets.length;
            const userId = profile && profile.employeeId;
            const programmerId = profile.programmers[0].id;
            const bufferLength = buffer.length;
            const maxBufferSize = conf.scroll.bufferSize;
            if (bufferLength) {
                store.dispatch(showInfiniteScrollLoader(true));
                store.dispatch(getAssetsFromBuffer());
            }
            if (bufferLength === maxBufferSize) {
                getAssets(userId, programmerId, maxBufferSize, assetsLength + bufferLength).then(response => {
                    const newAssets = response.data.assets;
                    if (_.isEmpty(newAssets)) {
                        return;
                    }
                    newAssets.forEach(asset => {
                        this.images[asset.assetUUID] = new Image();
                        this.images[asset.assetUUID].src = asset.thumbnail256x144Url;
                    });
                    store.dispatch(showInfiniteScrollLoader(false));
                    store.dispatch(refillBuffer(newAssets));
                });
            } else {
                store.dispatch(showInfiniteScrollLoader(false));
            }
        }
    }

    logout() {
        authApi.logout().then(() => {
            store.dispatch(logoutSuccess());
            this.props.router.push('/login');
            store.dispatch(clearAssets());
        });
    }

    render() {
        if (_.isEmpty(this.props.assets)) {
            return <EmptyGallery title="My Gallery" icon="image" avatar={this.props.avatar}
                                 logout={this.logout.bind(this)}>You have no media items yet.</EmptyGallery>
        }
        return <div>
            <Gallery assets={this.props.assets} userId={this.props.userId} avatar={this.props.avatar}
                        logout={this.logout.bind(this)}
                        onScroll={this.onScroll.bind(this)}/>
            {this.props.children}
        </div>;
    }
}

const mapStateToProps = function(store) {
    return {
        assets: store.assetsState.assets,
        userId: store.userProfile.employeeId,
        avatar: store.userProfile.avatar
    };
};

export default connect(mapStateToProps)(GalleryContainer);
